/*
 * marcel-video-fix.js — 24. 8. 2026
 *
 * Rieši dve veci nájdené pri diagnostike produktovej stránky:
 *
 *  1) VÁHA VIDEÍ. Shopify z každého videa vyrobí verzie 480p / 720p / 1080p,
 *     ale téma natvrdo používa len 1080p (4,8 Mbps). Na stránke trenchcoatu
 *     to je 10,9 MB videa. Prepnutie na 720p ušetrí 38 % (4,1 MB) bez
 *     viditeľnej straty — video sa zobrazuje v galérii, nie na celú plochu.
 *
 *  2) JS CHYBY. Keď sa spustí druhé video, téma prvé pozastaví a jeho
 *     neukončený play() skončí neošetrenou výnimkou (AbortError). Rovnako
 *     view-transitions pri pridaní do košíka (InvalidStateError). Sú
 *     neškodné, ale Clarity ich počíta ako chyby stránky. Tu ich utíšime.
 *
 * Súbor je defenzívny: každá časť je v try/catch, takže nikdy nezhodí web.
 */
(() => {
  "use strict";

  /* ---------- 1) ľahšia verzia videa ---------- */

  // Chceš ešte menšie? Zmeň na "SD-480p-1.2Mbps" (úspora 75 %, ale mäkší obraz).
  const RENDITION = "HD-720p-3.0Mbps";
  const HEAVY = "HD-1080p-4.8Mbps";
  const lighten = (text) => text.split(HEAVY).join(RENDITION);

  function lightenTree(root) {
    if (!root || !root.querySelectorAll) return;
    try {
      // deferred-media drží video v <template>, kým ho používateľ nespustí
      root.querySelectorAll("template").forEach((tpl) => {
        if (tpl.innerHTML.includes(HEAVY)) tpl.innerHTML = lighten(tpl.innerHTML);
      });
      // a rovnako už vložené <video> / <source>
      root.querySelectorAll("video[src], video source[src]").forEach((el) => {
        const src = el.getAttribute("src") || "";
        if (!src.includes(HEAVY)) return;
        el.setAttribute("src", lighten(src));
        const video = el.tagName === "VIDEO" ? el : el.closest("video");
        if (video && typeof video.load === "function") video.load();
      });
    } catch (err) {
      console.warn("[marcel-video-fix] preskočené:", err);
    }
  }

  function boot() {
    lightenTree(document);
    // Sekcie sa dorenderúvajú (galéria, rýchly náhľad, košík) — sleduj zmeny
    try {
      new MutationObserver((mutations) => {
        for (const m of mutations) {
          m.addedNodes.forEach((node) => {
            if (node.nodeType === 1) lightenTree(node);
          });
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    } catch (err) {
      console.warn("[marcel-video-fix] observer nebeží:", err);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  /* ---------- 2) utíšenie neškodných výnimiek ---------- */

  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    if (!reason || !reason.name) return;
    const msg = String(reason.message || "");
    const benign =
      // prehrávanie prerušené pauzou alebo šetrením batérie
      (reason.name === "AbortError" && msg.includes("play()")) ||
      // prechod medzi stránkami prerušený (napr. klik počas animácie)
      (reason.name === "InvalidStateError" && msg.includes("Transition was aborted"));
    if (benign) event.preventDefault();
  });
})();